import React, { useEffect ,useState} from "react";
import { useLocation } from "react-router-dom";
import "../Draft/Draft.css"
import { Container } from "react-bootstrap";

function Camsresponse() {
  const location = useLocation();
  const [params, setParams] = useState({});
  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const paramsObject = {};
    for (let [key, value] of searchParams.entries()) {
      paramsObject[key] = value;
    }
    setParams(paramsObject);
  }, [location.search]);

  return (
    // <div>
    //  <h1>Response page</h1>
    //   <pre>{JSON.stringify(params, null, 2)}</pre>
    // </div>
    <>
    <div className="draft-main">
      <Container>
        <div className="draft-inner-main" style={{padding : 20, display : "flex", justifyContent : "center", alignItems : "center"}}>
        {/* <h1>Response page</h1> */}
       {/* <pre>{JSON.stringify(params, null, 2)}</pre> */}

       {Object.keys(params).map((key) => (
          <p key={key} style={{margin : 10}}>
            <strong>{key}</strong>: {params[key]}

          </p>
        ))}
   
        </div>
      </Container>
    </div>
    </>
  );
}

export default Camsresponse;


// http://localhost:710/Camsresponse?response=User%20has%20cancelled%20the%20KYC%20process



